import { createApp } from "vue";
import App from "./App.vue";
import "bootstrap/dist/css/bootstrap.css";
import bootsratp from "bootstrap/dist/js/bootstrap.bundle.js";
import i18n, { loadLocaleMessages } from "./i18n";
import router from "./router";
import "@/assets/scss/style.scss";
import "@/assets/libs/@iconscout/unicons/css/line.css";
import Vue3Toastify from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { createHead } from "@vueuse/head";
//import "vuetify/styles";
//import { createVuetify } from "vuetify";
//import * as components from "vuetify/components";
//import * as directives from "vuetify/directives";
//import "@mdi/font/css/materialdesignicons.css";
//import '@/assets/libs/@mdi/font/css/materialdesignicons.min.css';
//const vuetify = createVuetify({
//  components,
//  //directives,
//  /*theme: {
//    defaultTheme: "light",
//  },*/
//});
//import MasonryWall from "@yeger/vue-masonry-wall";

const app = createApp(App);
const head = createHead();
//app.use(MasonryWall);
app.use(router);
app.use(bootsratp);
app.use(i18n);
app.use(head);

app.use(Vue3Toastify, {
  autoClose: 3000,
  // ...
});
//app.use(vuetify);
loadLocaleMessages(i18n.global.locale.value).then(() => {
  app.mount("#app");
});
